export var EPropertyMemberTypes;
(function (EPropertyMemberTypes) {
    EPropertyMemberTypes["Admin"] = "ADMIN";
    EPropertyMemberTypes["Owner"] = "OWNER";
    EPropertyMemberTypes["Broker"] = "BROKER";
    EPropertyMemberTypes["IndexationManager"] = "INDEXATION_MANAGER";
    EPropertyMemberTypes["FinancialManager"] = "FINANCIAL_MANAGER";
    EPropertyMemberTypes["TechnicalManager"] = "TECHNICAL_MANAGER";
    EPropertyMemberTypes["AdministrativeManager"] = "ADMINISTRATIVE_MANAGER";
    EPropertyMemberTypes["ContractMember"] = "CONTRACT_MEMBER";
    EPropertyMemberTypes["TaskMember"] = "TASK_MEMBER";
    EPropertyMemberTypes["Tenant"] = "TENANT";
    EPropertyMemberTypes["FutureTenant"] = "FUTURE_TENANT";
    EPropertyMemberTypes["Parent"] = "PARENT";
    // Should not be used in frontend
    EPropertyMemberTypes["Signer"] = "SIGNER";
    EPropertyMemberTypes["Applicant"] = "APPLICANT";
})(EPropertyMemberTypes || (EPropertyMemberTypes = {}));
export var EPropertyMemberFromString = new Map([
    ["ADMIN", EPropertyMemberTypes.Admin],
    ["OWNER", EPropertyMemberTypes.Owner],
    ["BROKER", EPropertyMemberTypes.Broker],
    ["INDEXATION_MANAGER", EPropertyMemberTypes.IndexationManager],
    ["FINANCIAL_MANAGER", EPropertyMemberTypes.FinancialManager],
    ["TECHNICAL_MANAGER", EPropertyMemberTypes.TechnicalManager],
    ["ADMINISTRATIVE_MANAGER", EPropertyMemberTypes.AdministrativeManager],
    ["TASK_MEMBER", EPropertyMemberTypes.TaskMember],
    ["CONTRACT_MEMBER", EPropertyMemberTypes.ContractMember],
    ["TENANT", EPropertyMemberTypes.Tenant],
    ["PARENT", EPropertyMemberTypes.Parent],
]);
export var EPropertyAdjoined;
(function (EPropertyAdjoined) {
    EPropertyAdjoined["Freestanding"] = "freestanding";
    // cSpell:ignore oneside
    EPropertyAdjoined["OneSide"] = "oneside";
    // cSpell:ignore bothsides
    EPropertyAdjoined["BothSides"] = "bothsides";
    EPropertyAdjoined["Unknown"] = "unknown";
})(EPropertyAdjoined || (EPropertyAdjoined = {}));
export var EPropertyForRentStatus;
(function (EPropertyForRentStatus) {
    EPropertyForRentStatus["None"] = "none";
    EPropertyForRentStatus["ForRent"] = "forRent";
    EPropertyForRentStatus["InOption"] = "inOption";
})(EPropertyForRentStatus || (EPropertyForRentStatus = {}));
export var EPropertyEPCLabel;
(function (EPropertyEPCLabel) {
    EPropertyEPCLabel["Unknown"] = "unknown";
    EPropertyEPCLabel["NoEPCAvailable"] = "NA";
    EPropertyEPCLabel["APlus"] = "A+";
    EPropertyEPCLabel["A"] = "A";
    EPropertyEPCLabel["B"] = "B";
    EPropertyEPCLabel["C"] = "C";
    EPropertyEPCLabel["D"] = "D";
    EPropertyEPCLabel["E"] = "E";
    EPropertyEPCLabel["F"] = "F";
    EPropertyEPCLabel["G"] = "G";
})(EPropertyEPCLabel || (EPropertyEPCLabel = {}));
export var EElectricityType;
(function (EElectricityType) {
    EElectricityType["Single"] = "single";
    EElectricityType["Double"] = "double";
    EElectricityType["Unknown"] = "unknown";
})(EElectricityType || (EElectricityType = {}));
export var EElectricityMeterType;
(function (EElectricityMeterType) {
    EElectricityMeterType["Standard"] = "standard";
    EElectricityMeterType["Opening"] = "opening";
    EElectricityMeterType["Budget"] = "budget";
    EElectricityMeterType["Empty"] = "empty";
})(EElectricityMeterType || (EElectricityMeterType = {}));
export var ENaturalGasAvailable;
(function (ENaturalGasAvailable) {
    ENaturalGasAvailable["Available"] = "available";
    ENaturalGasAvailable["Unavailable"] = "unavailable";
    ENaturalGasAvailable["Unknown"] = "unknown";
})(ENaturalGasAvailable || (ENaturalGasAvailable = {}));
export var ENaturalGasMeterType;
(function (ENaturalGasMeterType) {
    ENaturalGasMeterType["Standard"] = "standard";
    ENaturalGasMeterType["Opening"] = "opening";
    ENaturalGasMeterType["Budget"] = "budget";
    ENaturalGasMeterType["Empty"] = "empty";
})(ENaturalGasMeterType || (ENaturalGasMeterType = {}));
export var EHeatingType;
(function (EHeatingType) {
    EHeatingType["NaturalGas"] = "NATURAL_GAS";
    EHeatingType["Electricity"] = "ELECTRICITY";
    EHeatingType["HeatPump"] = "HEAT_PUMP";
    EHeatingType["FuelOil"] = "FUEL_OIL";
    EHeatingType["Coal"] = "COAL";
    EHeatingType["Other"] = "OTHER";
    // The heating systems of the CRM field list refine the six above; both sets
    // stay valid, and the list's "electric" is Electricity, not a second value.
    // Mirrors EPropertyHeatingType in api-next.
    EHeatingType["GasBoiler"] = "GAS_BOILER";
    EHeatingType["CondensingGasBoiler"] = "CONDENSING_GAS_BOILER";
    EHeatingType["Underfloor"] = "UNDERFLOOR";
    EHeatingType["District"] = "DISTRICT";
})(EHeatingType || (EHeatingType = {}));
// The property fields a partner CRM can send, mirrored from api-next's
// property.types.ts. The values are what goes over the wire, so they are
// copied exactly rather than renamed to a dashboard convention.
// cSpell:ignore AREI Aluminium EPDM
export var EYesNoUnknown;
(function (EYesNoUnknown) {
    EYesNoUnknown["Yes"] = "YES";
    EYesNoUnknown["No"] = "NO";
    EYesNoUnknown["Unknown"] = "UNKNOWN";
})(EYesNoUnknown || (EYesNoUnknown = {}));
export var EOrientation;
(function (EOrientation) {
    EOrientation["North"] = "N";
    EOrientation["NorthEast"] = "NE";
    EOrientation["East"] = "E";
    EOrientation["SouthEast"] = "SE";
    EOrientation["South"] = "S";
    EOrientation["SouthWest"] = "SW";
    EOrientation["West"] = "W";
    EOrientation["NorthWest"] = "NW";
})(EOrientation || (EOrientation = {}));
export var EPropertyKitchenType;
(function (EPropertyKitchenType) {
    EPropertyKitchenType["NotFitted"] = "NOT_FITTED";
    EPropertyKitchenType["SemiFitted"] = "SEMI_FITTED";
    EPropertyKitchenType["FullyFitted"] = "FULLY_FITTED";
    EPropertyKitchenType["HyperEquipped"] = "HYPER_EQUIPPED";
    EPropertyKitchenType["UsSemiFitted"] = "US_SEMI_FITTED";
    EPropertyKitchenType["UsFullyFitted"] = "US_FULLY_FITTED";
    EPropertyKitchenType["UsHyperEquipped"] = "US_HYPER_EQUIPPED";
})(EPropertyKitchenType || (EPropertyKitchenType = {}));
export var EPropertyCondition;
(function (EPropertyCondition) {
    EPropertyCondition["NewBuild"] = "NEW_BUILD";
    EPropertyCondition["ReadyToMoveIn"] = "READY_TO_MOVE_IN";
    EPropertyCondition["Renovated"] = "RENOVATED";
    EPropertyCondition["ToRefresh"] = "TO_REFRESH";
    EPropertyCondition["ToRenovate"] = "TO_RENOVATE";
    EPropertyCondition["ToRestore"] = "TO_RESTORE";
})(EPropertyCondition || (EPropertyCondition = {}));
export var EPropertyPetsAllowedDetail;
(function (EPropertyPetsAllowedDetail) {
    EPropertyPetsAllowedDetail["SmallPets"] = "SMALL_PETS";
    EPropertyPetsAllowedDetail["LargePets"] = "LARGE_PETS";
    EPropertyPetsAllowedDetail["AllPets"] = "ALL_PETS";
})(EPropertyPetsAllowedDetail || (EPropertyPetsAllowedDetail = {}));
export var EPropertyGlazingType;
(function (EPropertyGlazingType) {
    EPropertyGlazingType["Single"] = "SINGLE";
    EPropertyGlazingType["Double"] = "DOUBLE";
    EPropertyGlazingType["Triple"] = "TRIPLE";
    EPropertyGlazingType["Mixed"] = "MIXED";
})(EPropertyGlazingType || (EPropertyGlazingType = {}));
export var EPropertyHeatingDistribution;
(function (EPropertyHeatingDistribution) {
    EPropertyHeatingDistribution["Individual"] = "INDIVIDUAL";
    EPropertyHeatingDistribution["Collective"] = "COLLECTIVE";
})(EPropertyHeatingDistribution || (EPropertyHeatingDistribution = {}));
export var EPropertyFloorType;
(function (EPropertyFloorType) {
    EPropertyFloorType["Parquet"] = "PARQUET";
    EPropertyFloorType["Tiled"] = "TILED";
    EPropertyFloorType["Carpet"] = "CARPET";
    EPropertyFloorType["Laminate"] = "LAMINATE";
    EPropertyFloorType["Vinyl"] = "VINYL";
    EPropertyFloorType["Concrete"] = "CONCRETE";
    EPropertyFloorType["NaturalStone"] = "NATURAL_STONE";
    EPropertyFloorType["Wood"] = "WOOD";
    EPropertyFloorType["Other"] = "OTHER";
})(EPropertyFloorType || (EPropertyFloorType = {}));
export var EPropertyRoofMaterial;
(function (EPropertyRoofMaterial) {
    EPropertyRoofMaterial["Tiles"] = "TILES";
    EPropertyRoofMaterial["NaturalSlate"] = "NATURAL_SLATE";
    EPropertyRoofMaterial["ArtificialSlate"] = "ARTIFICIAL_SLATE";
    EPropertyRoofMaterial["Bitumen"] = "BITUMEN";
    EPropertyRoofMaterial["Epdm"] = "EPDM";
    EPropertyRoofMaterial["Other"] = "OTHER";
})(EPropertyRoofMaterial || (EPropertyRoofMaterial = {}));
export var EPropertyRoofType;
(function (EPropertyRoofType) {
    EPropertyRoofType["Flat"] = "FLAT";
    EPropertyRoofType["Gable"] = "GABLE";
    EPropertyRoofType["Butterfly"] = "BUTTERFLY";
    EPropertyRoofType["NorthLight"] = "NORTH_LIGHT";
})(EPropertyRoofType || (EPropertyRoofType = {}));
export var EPropertyWindowFrameMaterial;
(function (EPropertyWindowFrameMaterial) {
    EPropertyWindowFrameMaterial["Wood"] = "WOOD";
    EPropertyWindowFrameMaterial["Pvc"] = "PVC";
    EPropertyWindowFrameMaterial["Aluminium"] = "ALUMINIUM";
    EPropertyWindowFrameMaterial["Mixed"] = "MIXED";
})(EPropertyWindowFrameMaterial || (EPropertyWindowFrameMaterial = {}));
export var EPropertyEnvironmentType;
(function (EPropertyEnvironmentType) {
    EPropertyEnvironmentType["Residential"] = "RESIDENTIAL";
    EPropertyEnvironmentType["Quiet"] = "QUIET";
    EPropertyEnvironmentType["CityCenter"] = "CITY_CENTER";
    EPropertyEnvironmentType["Rural"] = "RURAL";
})(EPropertyEnvironmentType || (EPropertyEnvironmentType = {}));
export var EPropertyElectricityCertificate;
(function (EPropertyElectricityCertificate) {
    EPropertyElectricityCertificate["CompliantArei"] = "COMPLIANT_AREI";
    EPropertyElectricityCertificate["NonCompliantArei"] = "NON_COMPLIANT_AREI";
    EPropertyElectricityCertificate["Pending"] = "PENDING";
    EPropertyElectricityCertificate["NotRequested"] = "NOT_REQUESTED";
})(EPropertyElectricityCertificate || (EPropertyElectricityCertificate = {}));
export var EPropertyFloodScore;
(function (EPropertyFloodScore) {
    EPropertyFloodScore["ClassA"] = "CLASS_A";
    EPropertyFloodScore["ClassB"] = "CLASS_B";
    EPropertyFloodScore["ClassC"] = "CLASS_C";
    EPropertyFloodScore["ClassD"] = "CLASS_D";
})(EPropertyFloodScore || (EPropertyFloodScore = {}));
export var EPropertyTypeId;
(function (EPropertyTypeId) {
    EPropertyTypeId[EPropertyTypeId["Group"] = 1] = "Group";
    EPropertyTypeId[EPropertyTypeId["House"] = 2] = "House";
    EPropertyTypeId[EPropertyTypeId["Apartment"] = 3] = "Apartment";
    EPropertyTypeId[EPropertyTypeId["StudentResidence"] = 4] = "StudentResidence";
    EPropertyTypeId[EPropertyTypeId["Commercial"] = 5] = "Commercial";
    EPropertyTypeId[EPropertyTypeId["ParkingLot"] = 6] = "ParkingLot";
    EPropertyTypeId[EPropertyTypeId["Garage"] = 7] = "Garage";
    // Other = 8,
    EPropertyTypeId[EPropertyTypeId["Office"] = 9] = "Office";
    EPropertyTypeId[EPropertyTypeId["Warehouse"] = 10] = "Warehouse";
    EPropertyTypeId[EPropertyTypeId["Shed"] = 11] = "Shed";
    EPropertyTypeId[EPropertyTypeId["Storage"] = 12] = "Storage";
})(EPropertyTypeId || (EPropertyTypeId = {}));
export var EPropertyTypes;
(function (EPropertyTypes) {
    EPropertyTypes["Group"] = "group";
    EPropertyTypes["Building"] = "building";
    EPropertyTypes["House"] = "home";
    EPropertyTypes["Apartment"] = "apartment";
    EPropertyTypes["StudentResidence"] = "student_residence";
    EPropertyTypes["Commercial"] = "commercial";
    EPropertyTypes["ParkingLot"] = "parking_lot";
    EPropertyTypes["Garage"] = "garage";
    EPropertyTypes["Office"] = "office";
    EPropertyTypes["Warehouse"] = "warehouse";
    EPropertyTypes["Shed"] = "shed";
    EPropertyTypes["Storage"] = "storage";
    EPropertyTypes["Other"] = "other";
})(EPropertyTypes || (EPropertyTypes = {}));
